import { ReactNode } from 'react';

import { Col, Row } from 'approot/shared/grid/grid';
import * as Styled from './footer.style';
import { FooterSubjectsPlaceholder } from 'approot/shared/layout/footer/footer-subjects-placeholder';
import { NUMBER_OF_DISCIPLINES_US } from 'global/constants';

type Discipline = {
  name: string;
  slug: string;
  label: string;
};

export const FooterDisciplineLinks = ({
  render,
  loading,
  disciplines,
  stimulusLinks,
}: {
  render: (discipline: Discipline) => ReactNode;
  disciplines: Discipline[] | null;
  loading: boolean;
  stimulusLinks: ReactNode;
}) => {
  const numberOfSubjects = NUMBER_OF_DISCIPLINES_US + 1;
  // 'Earth and Space Sciences' wraps across two rows

  return (
    <Row>
      <Col sm={6}>
        <Styled.FooterGroup>
          {loading ? (
            <FooterSubjectsPlaceholder numberOfSubjects={numberOfSubjects} />
          ) : (
            <Styled.FooterLinksFadeIn>
              {disciplines?.map(discipline => render(discipline))}
            </Styled.FooterLinksFadeIn>
          )}
        </Styled.FooterGroup>
      </Col>
      <Col sm={6}>
        <Styled.FooterGroup>{stimulusLinks}</Styled.FooterGroup>
      </Col>
    </Row>
  );
};
